import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputTextarea } from "primereact/inputtextarea";
import { roomPersonTypeActions } from "../../store/roompersontype-store/roompersontype-slice";
import { uiActions } from "../../store/ui-slice";
import { GetConferences } from "../../store/conferences-store/conference-actions";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";

let restartPage = false;

const RoomPersonTypeForms = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isValid = useSelector(
    (state) => state.roomPersonType.roomPersonTypeValidation
  );
  const conferences = useSelector((state) => state.conference.conferences);
  const auth = useSelector((state) => state.auth);
  const roompersontype = props.roompersontype;
  const notification = useSelector((state) => state.ui.notification);
  const [selectConference, setSelectConference] = useState({
    code: 0,
    name: "",
  });

  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      roompersontype.id > 0 &&
      restartPage
    ) {
      dispatch(roomPersonTypeActions.restartState());
      window.location.href = "/roompersontypes";
    }
  }, [roompersontype, dispatch, navigate, notification]);

  useEffect(() => {
    if (conferences.length === 0) {
      dispatch(GetConferences(auth.UserInfo.email, false, false));
    }
  }, [conferences.length, dispatch, auth]);
  useEffect(() => {
    if (
      roompersontype.conferences &&
      roompersontype.conferences.id &&
      roompersontype.conferences.id > 0 &&
      roompersontype.conferences.name !== ""
    ) {
      setSelectConference({
        code: roompersontype.conferences.id,
        name: roompersontype.conferences.name,
      });
    }
  }, [roompersontype]);

  const onChangeHandler = (id, value) => {
    if (id === "conferences") {
      setSelectConference(value);
      dispatch(
        roomPersonTypeActions.modifyPropertyValue({
          id,
          value: { id: value.code, name: value.name },
        })
      );
    } else {
      dispatch(roomPersonTypeActions.modifyPropertyValue({ id, value }));
    }

    if (value !== "" ) {
      dispatch(roomPersonTypeActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(roomPersonTypeActions.setFieldValid({ id, value: false }));
    }
  };
  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (roompersontype.name === "") {
      dispatch(
        roomPersonTypeActions.setFieldValid({ id: "name", value: false })
      );
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else {
      
      dispatch(props.actionRoomPersonType(roompersontype, auth.UserInfo.email));
      restartPage = true;
    }
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };

  return (
    <>
      <Card
        style={{
          backgroundColor: "#142f47",
          marginLeft: "1%",
          marginTop: "-16px",
          boxShadow: "none",
          height: "100%",
          width: "99%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "#fff" }}>
                Tipo de persona en habitación:
                <span style={{ color: "lightskyblue", marginLeft: "1%" }}>
                  {roompersontype &&
                    roompersontype.name &&
                    roompersontype.name.toUpperCase()}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-6">
              <label
                htmlFor="name"
                style={{ fontSize: "large", color: "#35c4dc" }}
              >
                Tipo de person Habitación:
              </label>
              <InputText
                id="name"
                value={roompersontype.name}
                onChange={(e) => onChangeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>
            <div className="field col-12">
              <label
                htmlFor="IdConference"
                style={{ fontSize: "large", color: "#35c4dc" }}
              >
                Congreso
              </label>
              <Dropdown
                className="w-full text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round outline-none focus:border-primary"
                value={selectConference}
                onChange={(e) => onChangeHandler("conferences", e.value)}
                options={conferences}
                optionLabel="name"
                placeholder="Seleccione Congreso"
                filter
                style={{ width: "100%" }}
              />
            </div>
            <div className="field col-12">
              <label
                htmlFor="IdConference"
                style={{ fontSize: "large", color: "#35c4dc" }}
              >
                Precio
              </label>
              <br />
              <InputNumber
                value={roompersontype.price}
                onValueChange={(e) => onChangeHandler("price", e.value)}
                minFractionDigits={2}
                maxFractionDigits={2}
              />
            </div>
            <div className="field col-12 md:col-2">
              <label
                htmlFor="creditCardOnly"
                style={{
                  fontSize: "large",
                  color: "#35c4dc",
                  marginRight: "10px",
                }}
              >
                Requerido
              </label>
              <InputSwitch
                checked={roompersontype.required}
                onChange={(e) => onChangeHandler("required", e.value)}
              />
            </div>
            <div className="field col-12 md:col-8">
              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "#35c4dc" }}
              >
                Descripción:
              </label>
              <InputTextarea
                id="description"
                rows={4}
                cols={10}
                value={roompersontype.description}
                onChange={(e) => onChangeHandler("description", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                navigate("/roompersontypes");
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>
      </Card>
    </>
  );
};
export default RoomPersonTypeForms;
